import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { PaymentService } from "src/app/services/payment/user-wallet.service";
import { ScreenSizeService } from "src/app/services/screen-size.service";
import { finalize } from "rxjs/operators";
import { Router } from "@angular/router"; 
import { enableDebugTools } from "@angular/platform-browser";

@Component({
  selector: "app-buy-tokens",
  templateUrl: "./buy-tokens.component.html",
  styleUrls: ["./buy-tokens.component.scss"],
})
export class BuyTokensComponent implements OnInit {
  modalForm!: FormGroup;
  isMobile: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = "";

  constructor(
    private fb: FormBuilder,
    private paymentService: PaymentService,
    private screenSizeService: ScreenSizeService,
    public dialogRef: MatDialogRef<BuyTokensComponent>,
    private router: Router // ✨ INJECT ROUTER
  ) {
    this.modalForm = this.fb.group({
      token_amount: [null, [Validators.required, Validators.min(1)]],
    });
  }

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  get token_amount() {
    return this.modalForm.get("token_amount");
  }

    getDeviceType(): string {
    const ua = navigator.userAgent.toLowerCase();

    if (/android/.test(ua)) return "android";
    if (/iphone|ipad|ipod/.test(ua)) return "ios";
    return "web";
  }

  submit() {
    if (this.modalForm.invalid) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = "";

    const payload = {
      amount: parseInt(this.token_amount?.value, 10),
      payment_method: "icici_cbdc",
      device: this.getDeviceType(),
    };
    console.log(payload)

    this.paymentService
      .addTokens(payload)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          // On success, create the context for the payment page
          console.log(res);
          const paymentContext = {
              qr_code: res.qr_code,
            intentLink: res.payment_intent.intent_link,
            txId: res.payment_intent.transaction_id,
            amount: res.payment_intent.amount,
            message: res.payment_intent.message,
            returnRoute: '/user-wallet', // Where to go back after success
            display: { title: 'Wallet Top-up' }
          };

          // Save to session storage for robustness
          sessionStorage.setItem('pendingPaymentContext', JSON.stringify(paymentContext));

          // Close the dialog and navigate to the payment page
          this.dialogRef.close();
          this.router.navigate(['/payment'], { state: paymentContext });
        },
        error: (err) => {
          console.error("Error creating payment intent:", err);
          this.errorMessage =
            err?.error?.detail?.toString() ||
            "Could not initiate payment. Please try again.";
        },
      });
  }
}